module.exports = __webpack_public_path__ + "e0474d2a626c113347f05dc014e8a3a1.png";